import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

const INTERNAL_HOST = 'apigateway.co';

/**
 * Fetches apigateway.co URLs with credentials for a signed URL; others pass through.
 * Exact hostname match — substring would authenticate attacker-shaped URLs.
 * Errors become null so they don't propagate into the subscriber's view.
 */
export function resolveCallRecordingUrl(http: HttpClient, url: string | null | undefined): Observable<string | null> {
  if (!url || !url.trim()) {
    return of(null);
  }
  let hostname: string;
  try {
    hostname = new URL(url).hostname;
  } catch {
    return of(null);
  }
  if (hostname !== INTERNAL_HOST && !hostname.endsWith('.' + INTERNAL_HOST)) {
    return of(url);
  }
  return http
    .get(url, { responseType: 'text', withCredentials: true })
    .pipe(catchError(() => of(null)));
}
